<template lang="pug">
.campo(:class="`col grid-12-s ${f.tamanho == 'P' && 'g3'} ${f.tamanho == 'M' && 'g5'} ${f.tamanho == 'G' && 'g12'}`")
    label {{ f.rotulo }}
    template(v-if="!read")
        input(v-if="f.tipo == 'texto'" @change="({target:{value}})=>up(value)" :value="v" :placeholder="f.rotulo")
        input(v-if="f.tipo == 'inteiro'" @change="({target:{value}})=>up(value)" :value="v" :placeholder="f.rotulo" type="number")
        input(v-if="f.tipo == 'data'" @change="({target:{value}})=>up(value)" :value="v" type="date" :placeholder="f.rotulo")
        input(v-if="f.tipo == 'hora'" @change="({target:{value}})=>up(value)" :value="v" :placeholder="f.rotulo" type="time")
        Money(v-if="f.tipo == 'real'" @change="({target:{value}})=>up(value)" :value="v" v-bind="money" placeholder="0,00")
        select(v-if="f.tipo == 'lista'" @change="({target:{value}})=>up(value)" :selected="v")
            option(:value="null") Selecione
            option(v-for="i in f.itens_lista" :value="i") {{i}}
    template(v-else)
        strong {{v}}
        
</template>


<script>
import { Money } from "v-money";

export default {
    name: "Campo",
    components: { Money },
    props: { f: Object, up: Function, v: String, read: Boolean },
    data() {
        return {
            money: {
                decimal: ",",
                thousands: ".",
                precision: 2,
                masked: false,
            },
        };
    }
}
</script>

<style lang="sass">
@use "@/assets/scss/vars.scss" as *
.campo
    margin: 10px
    strong
        color: $font-color
        margin-top: 6px
</style>